import { toast } from "@/lib/toast";

/** Fetch a URL and save it to disk under `filename`. */
export async function downloadUrl(url: string, filename: string) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to download file");
    }
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename || "download";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.error("Download failed", error);
    toast.error("Unable to download file. Please try again.");
  }
}

/** Last path segment of a URL, for naming a download. */
export function filenameFromUrl(url: string, fallback = "image"): string {
  // A data: URL has no filename — its "pathname" is the whole payload.
  if (url.startsWith("data:")) return fallback;
  try {
    const name = new URL(url, window.location.origin).pathname.split("/").pop();
    return name ? decodeURIComponent(name) : fallback;
  } catch {
    return fallback;
  }
}
